var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"margin-bottom":"3px"}},[_vm._v(" 注文書番号: "),_c('a',{staticStyle:{"color":"#408d7c","text-decoration":"underline"},attrs:{"target":"_blank","href":'https://www.rakumart.com/api/ordno.php?type=3&ordno=' + _vm.ordno}},[_vm._v(" "+_vm._s(_vm.ordno)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }